import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

import { TranslationRepository } from '@core/i18n/domain/interfaces/translation.interface';
import { Language } from '@core/i18n/domain/language';
import { ITranslationsApiResponse } from '@core/i18n/domain/translation.types';
import { withLanguage } from '@core/http/accept-language.context';

/**
 * HttpTranslationRepository — the real API source (same interface as the mock).
 *
 * ⚠️ Endpoint/contract is a PLACEHOLDER. Once the API README is provided,
 * adjust the URL, query params and response shape here ONLY — nothing else
 * in the i18n pipeline needs to change. See `src/app/v2/README.md`.
 */
@Service({ autoProvided: false })
export class HttpTranslationRepository extends TranslationRepository {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/api/translations`;

  override getTranslations(lang: Language): Observable<ITranslationsApiResponse> {
    // The real API resolves the language from the `Accept-Language` HEADER, not a
    // query param (see common/core/translations/API-INTEGRATION.md). `withLanguage`
    // tags the request so the global headersInterceptor sends `Accept-Language: <lang>`.
    return this.http.get<ITranslationsApiResponse>(this.baseUrl, {
      context: withLanguage(lang),
    });
  }
}
